import { useState, memo } from 'react';
import * as S from './AppTypeFilterMenu.styled';
import { DropDownArrowUp, DropDownArrowDown } from 'assets/icons';
import { appTypeFilterItems } from 'constants';

const AppTypeFilterMenu = ({ handleChangeAppTypeFilter, appTypeFilterState }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <S.FilterContainer>
      <S.Label>Show:&nbsp;</S.Label>
      {isOpen && <S.Slice onClick={() => setIsOpen(false)} />}
      <S.FilterButtonWrapper>
        <S.FilterHeader isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
          <span>{appTypeFilterState.name}</span>
          {isOpen ? <DropDownArrowDown /> : <DropDownArrowUp />}
        </S.FilterHeader>
        <S.Menu isOpen={isOpen}>
          <S.ListWrap>
            <S.DropDownList>
              {appTypeFilterItems.map((menuItem) => (
                <S.ListItem
                  key={menuItem.id}
                  onClick={() => {
                    handleChangeAppTypeFilter(menuItem);
                    setIsOpen(false);
                  }}
                >
                  <span>{menuItem.name}</span>
                </S.ListItem>
              ))}
            </S.DropDownList>
          </S.ListWrap>
        </S.Menu>
      </S.FilterButtonWrapper>
    </S.FilterContainer>
  );
};

export default memo(AppTypeFilterMenu);
